import { styled } from 'stitches.config'

export const HeroRoot = styled('section', {
  backgroundColor: '$tertiary-200',
  paddingTop: '$5',
  paddingBottom: '$6',
  width: '100%',
  position: 'relative',
  paddingLeft: '0 !important',
  paddingRight: '0 !important',

  '@bp2': {
    paddingLeft: '$3',
    paddingRight: '$3',
  },
  '@bp3': {
    paddingLeft: '15.9vw',
    paddingRight: '15.9vw',
  },
})

export const HeroContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2.5rem',
  width: '100%',
  paddingLeft: '$3',
  paddingRight: '$3',
  '& img': {
    display: 'block !important',
    width: '100% !important',
    height: 'auto !important',
    objectFit: 'cover !important',
  },
  '@bp2': {
    paddingLeft: '$3',
    paddingRight: '$3',
    '& img': {
      width: 'auto',
      height: 'auto',
      objectFit: 'contain',
    },
  },
  '@bp3': {
    paddingLeft: '15.9vw',
    paddingRight: '15.9vw',
  },
})

export const HeroTitle = styled('h1', {
  color: '$primary-500',
  fontSize: '$h2',
  textAlign: 'center',
  textWrap: 'pretty',
  lineHeight: '1',
  '@bp2': {
    paddingLeft: '$3',
    paddingRight: '$3',
    fontSize: '$h1',
    textWrap: 'normal',
  },
})
